import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Info } from "lucide-react";
import { ReportWarning } from "@/hooks/useProgressiveReports";

interface ReportWarningsBannerProps {
  warnings: ReportWarning[];
}

export const ReportWarningsBanner = ({ warnings }: ReportWarningsBannerProps) => {
  if (!warnings || warnings.length === 0) return null;

  return (
    <Alert className="mb-4 border-border bg-muted/50 text-foreground">
      <Info className="h-4 w-4 text-muted-foreground" />
      <AlertTitle className="text-foreground">Inventory snapshot note</AlertTitle>
      <AlertDescription className="text-muted-foreground">
        <ul className="list-disc list-inside mt-2 space-y-1">
          {warnings.map((warning, index) => (
            <li key={index} className="text-sm">
              {warning.connectionName && <strong>{warning.connectionName}: </strong>}
              {warning.message}
            </li>
          ))}
        </ul>
      </AlertDescription>
    </Alert>
  );
};
